import { Collection } from 'modules/core/lib/mobx-rest'

import CopyScheduleStatsModel from 'modules/shift_management/store/api/models/CopyScheduleStats'

class CopyScheduleStats extends Collection<CopyScheduleStatsModel> {
  get cacheKey(): string {
    return 'copyScheduleStats'
  }
  model() {
    return CopyScheduleStatsModel
  }
}

const singleton: CopyScheduleStats = new CopyScheduleStats()

export default singleton
